import { Condition } from '@staffino/model';
import { ConditionEvaluatorContext } from '../condition-evaluator-context';

export default async function legacyAnswer(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  const { blockId, score, choiceIds } = condition[1];
  const { score: selectedScore, choiceIds: selectedChoiceIds } =
    context.stateManager.getAggregatedFormData()[blockId] ?? {};
  if (score !== undefined) {
    if (selectedScore === undefined) {
      return false;
    }
    const normalizedScores = Array.isArray(score) ? score : [score];
    if (normalizedScores.includes(parseInt(selectedScore, 10))) {
      return true;
    }
  }
  if (choiceIds !== undefined) {
    if (selectedChoiceIds === undefined) {
      return false;
    }
    const normalizedChoiceIds = Array.isArray(choiceIds)
      ? choiceIds
      : [choiceIds];
    for (const id of selectedChoiceIds) {
      if (normalizedChoiceIds.includes(id)) {
        return true;
      }
    }
  }
  return false;
}
